import { useEffect, useState } from "react";

const WHATSAPP_NUMBER = "393473188828";
const TEL_NUMBER = "+393473188828";
const MESSAGE = encodeURIComponent(
  "Ciao! Ti scrivo dal portale NMA Agency, vorrei un contatto diretto."
);

/**
 * Floating action button fisso in basso a destra.
 * - Su mobile: link tel: (chiamata classica in un tap)
 * - Su desktop: link wa.me (WhatsApp Web / desktop)
 */
export default function WhatsAppFloat() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () =>
      setIsMobile(
        typeof window !== "undefined" &&
          window.matchMedia("(max-width: 767px)").matches
      );
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const href = isMobile
    ? `tel:${TEL_NUMBER}`
    : `https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`;

  const label = isMobile ? "Chiama Direttore" : "WhatsApp Direttore";

  return (
    <a
      href={href}
      target={isMobile ? "_self" : "_blank"}
      rel="noopener noreferrer"
      aria-label={label}
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5A] text-white shadow-2xl px-4 py-3 sm:px-5 sm:py-4 transition-all hover:scale-105 active:scale-95"
      style={{
        boxShadow:
          "0 10px 30px -8px rgba(37, 211, 102, 0.55), 0 4px 12px rgba(0,0,0,0.35)",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-6 h-6 sm:w-7 sm:h-7"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.6 5.94L0 24l6.34-1.66a11.87 11.87 0 0 0 5.72 1.46h.01c6.56 0 11.9-5.34 11.9-11.9a11.83 11.83 0 0 0-3.45-8.42ZM12.07 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.22-3.76.99 1-3.66-.24-.38a9.85 9.85 0 0 1-1.51-5.25c0-5.46 4.45-9.9 9.92-9.9 2.65 0 5.14 1.03 7.01 2.9a9.83 9.83 0 0 1 2.9 7.02c0 5.46-4.45 9.88-9.92 9.88Zm5.44-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.64-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.19-.24-.57-.48-.5-.66-.5h-.56c-.2 0-.5.07-.77.37-.27.3-1.02.99-1.02 2.42s1.05 2.81 1.2 3c.15.2 2.07 3.16 5.02 4.44.7.3 1.25.48 1.68.61.7.22 1.35.19 1.85.12.56-.08 1.76-.72 2-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35Z" />
      </svg>
      <span className="hidden sm:inline text-sm font-medium">{label}</span>
    </a>
  );
}
